import { useLocation, matchPath } from 'react-router-dom';

export default function useRouteMatchCompat(pathname) {
  const location = useLocation();
  const path = pathname || location.pathname;
  const match = matchPath({ path, end: false }, location.pathname);

  return {
    path,
    url: match?.pathname || location.pathname,
    isExact: match?.pathname === location.pathname,
    params: match?.params || {},
  };
}
